import React, { Fragment } from 'react';
import { Alert } from 'react-bootstrap';
import {
  resetPassword,
  clearError,
} from '../../redux/authentication/authentication_actions';
import { connect } from 'react-redux';
import logoImage from '../../assets/images/2e-building.png';


class RequestResetPasswordPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      isShowSuccess: false,
      validatingEmail: false,
    };
    this.handleBlurEmail = this.handleBlurEmail.bind(this);
  }

  onResetPasswordRequestSubmit() {
    const { email } = this.state;
    if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) return;
    this.props.resetPassword(email);
  }

  onValueChange(event, fieldName) {
    this.setState({ ...this.state, [fieldName]: event.target.value });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isResettingPwd && !this.props.isResettingPwd && !this.props.errorMessage) {
      this.setState({ isShowSuccess: true });
    }
  }

  backToLogin() {
    this.props.history.push('/');
  }

  handleBlurEmail() {
    this.setState({ validatingEmail: true });
  }

  renderEmailConfirmError() {
    if (this.state.validatingEmail && !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.email)) {
      return true;
    }
    return false;
  }

  componentDidMount() {
    this.props.clearError();
  }

  renderFormInput(isResettingPwd, errorMessage) {
    return (
      <Fragment>
        <div className="form-item js-form-item form-type-textfield js-form-type-textfield form-item-name js-form-item-name form-group">
          <label
            htmlFor="edit-email"
            className="control-label js-form-required form-required"
          >
            Email *
          </label>
          <input
            autoCorrect="none"
            autoCapitalize="none"
            spellCheck="false"
            className="form-text required form-control"
            id="edit-email"
            name="email"
            value={this.state.email}
            size="60"
            maxLength="60"
            type="text"
            onChange={event => this.onValueChange(event, 'email')}
            onBlur={this.handleBlurEmail}
            disabled={isResettingPwd}
            required
          />
        </div>
        {this.renderEmailConfirmError() ? (
          <div className="alert alert-danger" id="edit-email-wrong-pattern" >Email address is invalid</div>
        ) : null}
        {errorMessage && <div className="alert alert-danger" id="edit-invalid">{errorMessage}</div>}
        <div className="form-actions form-group js-form-wrapper form-wrapper">
          <button
            onClick={this.onResetPasswordRequestSubmit.bind(this)}
            type="submit"
            className="button js-form-submit form-submit btn-primary btn icon-before"
            id="edit-submit"
            disabled={this.state.email.length === 0 || isResettingPwd || this.renderEmailConfirmError()}
          >
          <span
            className="icon glyphicon glyphicon-log-in"
            aria-hidden="true"
          />
            {isResettingPwd ? 'Resetting...' : 'Reset Password'}
          </button>
        </div>
      </Fragment>
    );
  }

  renderForm() {
    const { isResettingPwd, errorMessage } = this.props;
    const { isShowSuccess } = this.state;
    return (
      <form
        className="user-register-form"
        onSubmit={() => this.onResetPasswordRequestSubmit()}
      >
        <div
          className="form-actions form-group js-form-wrapper form-wrapper"
        >
          <button
            onClick={this.backToLogin.bind(this)}
            type="button"
            className="button btn icon-before"
          >
            <span
              className="icon glyphicon glyphicon glyphicon-menu-left"
              aria-hidden="true"
            />
            Back to login
          </button>
        </div>

        {isShowSuccess ? this.renderSuccess() : this.renderFormInput(isResettingPwd, errorMessage)}
      </form>
    );
  }

  renderSuccess() {
    const { message } = this.props;
    return (
      <Alert bsStyle="info">
        {message}
      </Alert>
    );
  }

  render() {
    return (
      <div className="zenregister scrollable-container">
        <div className="register-container">
          <div className="register-header">
            <img style={{ width: '100%' }} src={logoImage} />
            <a style={{ fontSize: 20, paddingTop: 10 }} href="#">Building Energy Code</a>
          </div>
          <div className="register-content">
            {this.renderForm()}
          </div>
          <div className="register-footer" />
        </div>
      </div>
    );
  }

}

const mapStateToProps = state => ({
  message: state.authentication.message,
  errorMessage: state.authentication.errorMessage,
  isResettingPwd: state.authentication.resettingPwd,
});

const mapDispatchToProps = dispatch => ({
  resetPassword: (...args) => dispatch(resetPassword(...args)),
  clearError: (...args) => dispatch(clearError(...args)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RequestResetPasswordPage);



// WEBPACK FOOTER //
// ./src/pages/request_reset_password/RequestResetPasswordPage.js